export enum EmployerStatusTypeEnum {
  Active = 1,
  Inactive = 2
}
